import { Reason } from "./Reason";
import { type Reason as ReasonProps } from "../types";

type ReasonListProps = {
  reasons: ReasonProps[];
};

export const ReasonList = ({ reasons }: ReasonListProps) => (
  <div className="grid gap-6 md:grid-cols-3 mb-10" data-testid="reason-list">
    {reasons.map(({ icon, title, description }) => (
      <Reason key={title} icon={icon} title={title} description={description} />
    ))}
  </div>
);
